import React, { createContext, useContext, useState, useEffect, useLayoutEffect } from 'react';

type Theme = 'dark' | 'light';

interface ThemeContextType {
  theme: Theme;
  toggleTheme: () => void;
}

const ThemeContext = createContext<ThemeContextType | undefined>(undefined);

export function ThemeProvider({ children }: { children: React.ReactNode }) {
  const [theme, setTheme] = useState<Theme>(() => {
    // בדיקה אם יש preference ברחסטורג
    const saved = localStorage.getItem('catalyst-theme') as Theme | null;
    if (saved) return saved;
    
    // בדיקה של הגדרות מערכת
    if (window.matchMedia?.('(prefers-color-scheme: light)').matches) {
      return 'light';
    }
    
    return 'dark';
  });

  // תיקון מהיר כדי לא יהיה flash של light mode בטעינה
  useLayoutEffect(() => {
    const saved = localStorage.getItem('catalyst-theme') as Theme | null;
    const initialTheme = saved || 'dark';
    if (initialTheme === 'dark') {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
    }
  }, []);

  useEffect(() => {
    // שמירת ה-preference
    localStorage.setItem('catalyst-theme', theme);
    
    // עדכון ה-document class
    if (theme === 'light') {
      document.documentElement.classList.remove('dark');
    } else {
      document.documentElement.classList.add('dark');
    }
  }, [theme]);

  const toggleTheme = () => {
    setTheme(prev => prev === 'dark' ? 'light' : 'dark');
  };

  return (
    <ThemeContext.Provider value={{ theme, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
}

export function useTheme() {
  const context = useContext(ThemeContext);
  if (context === undefined) {
    throw new Error('useTheme must be used within ThemeProvider');
  }
  return context;
}
